import { render, staticRenderFns } from "./ElMediaWrapper.vue?vue&type=template&id=979f4bf0"
import script from "./ElMediaWrapper.vue?vue&type=script&lang=js"
export * from "./ElMediaWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports